import { render, staticRenderFns } from "./XVarsEditor.vue?vue&type=template&id=04584107&"
import script from "./XVarsEditor.vue?vue&type=script&lang=js&"
export * from "./XVarsEditor.vue?vue&type=script&lang=js&"
import style0 from "./XVarsEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports